export class PartnerStaticData {
    public static readonly DK_PARTNER_ID: string = '2010';
}
